/* eslint-disable react/no-unescaped-entities */
import React, { useMemo, useState } from 'react';
import { Button, Spin, message, Form, Radio, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from '@apollo/client';
import {
  UPDATE_PARTNER,
  QUERY_LIST_REFERRERS,
} from '~pages/dashboard/referral/partner-account/queries';
import { ExclamationCircleFilled } from '@ant-design/icons';

const DoubleConfirm = ({ onConfirm, loading, onCancel, children, visible }) => {
  return (
    <Popover
      placement="top"
      trigger="click"
      visible={visible}
      content={
        <div className="payment-preference-editor__popover">
          <div className="wrapper">
            <ExclamationCircleFilled className="icon" style={{ color: '#F9A600' }} />

            <div className="txt">
              Changing payment preferences will impact future transaction payouts but won't
              retroactively alter generated payouts, and assigned promotions will become invalid. Do
              you want to proceed with this change?
            </div>
          </div>
          <div className="btn_group">
            <Button type="ghost" onClick={onCancel}>
              No
            </Button>
            <Button loading={loading} type="primary" onClick={onConfirm}>
              Yes, change
            </Button>
          </div>
        </div>
      }
    >
      {children}
    </Popover>
  );
};

function PaymentPreferenceEditor({
  partnerId,
  paymentPreference,
  onClose,
  form: { getFieldDecorator, validateFields },
}) {
  const { t } = useTranslation();

  const [showDoubleConfirm, setShowDoubleConfirm] = useState(false);
  const { loading: referrerListLoading, data: referrerListResponse } = useQuery(
    QUERY_LIST_REFERRERS,
    {
      variables: {
        pageNumber: 1,
        pageSize: 100,
      },
    },
  );

  const referrerList = useMemo(() => {
    return (
      referrerListResponse?.referrers?.edges.map(edge => ({
        label: `${edge?.node?.firstName || ''} ${edge?.node?.lastName || ''}`,
        value: edge.node.id,
      })) || []
    );
  }, [referrerListResponse]);

  const [updatePartner, { loading: updatePartnerLoading }] = useMutation(UPDATE_PARTNER, {
    onError: e => {
      message.error(e.message);
    },
  });

  const handleSubmit = async () => {
    validateFields(async (err, values) => {
      if (!err) {
        const response = await updatePartner({
          variables: {
            input: { id: partnerId, paymentPreference: values.paymentPreference },
          },
        });
        if (response?.data?.updatePartner) {
          message.success('Update Partner Payment Preference Success');

          onClose();
        }
      }
    });
  };

  return (
    <>
      <div
        className="partner-register-city-editor__body"
        style={{ marginTop: '8px', paddingBottom: '12px' }}
      >
        <section className="partner-register-city-editor__section">
          {referrerListLoading && !referrerList.length ? (
            <div className="partner-register-city-editor__spin">
              <Spin />
            </div>
          ) : (
            <main className="partner-register-city-editor__main">
              <div className="">
                <Form>
                  <Form.Item label="Payment Preference">
                    {getFieldDecorator('paymentPreference', {
                      initialValue: paymentPreference,
                      rules: [{ required: true, message: 'You should seleted one of them.' }],
                    })(
                      <Radio.Group>
                        <Radio value="OFFLINE">Offline</Radio>
                        <Radio value="ONLINE">Online</Radio>
                      </Radio.Group>,
                    )}
                  </Form.Item>
                </Form>
              </div>
            </main>
          )}
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>

        <DoubleConfirm
          onConfirm={() => {
            handleSubmit();
          }}
          visible={showDoubleConfirm}
          loading={updatePartnerLoading}
          onCancel={() => {
            setShowDoubleConfirm(false);
          }}
        >
          <Button
            type="primary"
            size="large"
            className="partner-register-city-editor__save-button"
            loading={updatePartnerLoading}
            onClick={() => {
              setShowDoubleConfirm(true);
              // handleSubmit(owner, true)
            }}
          >
            {t('cms.referral.partner.detail.editor.btn.save')}
          </Button>
        </DoubleConfirm>
      </div>
    </>
  );
}

export default Form.create({ name: 'PaymentPreferenceEditor' })(PaymentPreferenceEditor);
